import { Autocomplete } from "@mantine/core";

const MantineAutoComplete = (props: any) => {
  const { label, placeholder, value, onChange, error, classNames, disabled, rightSection, leftSection, inputClassName, styleType } = props;
  
  const type: any = {
    mapSearch: {
      input: `h-cus-50 bg-white rounded-cus-40 opacity-100 pl-12 ${inputClassName}`,
    }
  }  

  return (
    <Autocomplete
      classNames={classNames ? classNames : type[styleType]}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
      rightSection={rightSection}
      leftSection={leftSection}
      autoComplete="off"
      {...props}
    />
  );
};

export default MantineAutoComplete;
